const DISHES = [
    {
        id: 0,
        name: 'Ginger Burger',
        image: 'assets/images/0burger.jpg',
        category: 'meal',
        label: 'Hot',
        price: '199',
        featured: true,
        description: 'This chicken burger gets an Asian-flavor twist with ginger and garlic. It\'s topped off with a fabulous coleslaw. If you like, serve the coleslaw as a side for grilled items, like chicken breasts, fish fillets or chops',
    },
    {
        id: 1,
        name: 'BBQ Chicken Pizza',
        image: 'assets/images/1pizza.jpg',
        category: 'meal',
        label: '',
        price: '599',
        featured: false,
        description: 'BBQ chicken pizza with tangy BBQ sauce, chicken, and red onion. Gouda cheese gives the homemade pizza the most delicious smoky flavor and cilantro adds a touch of freshness. My pizza dough recipe makes enough for two 12-inch pizzas, so you can freeze half for later. It’s an easy thick-style pizza crust with unbeatable flavor.',
    },
    {
        id: 2,
        name: 'French Fries',
        image: 'assets/images/2fries.jpg',
        category: 'appetizer',
        label: 'New',
        price: '120',
        featured: false,
        description: 'These are deep-fried, very thin, salted slices of potato that are usually served at room temperature. French fries have numerous variants, from thick-cut to shoestring, crinkle, curly and many other names.',
    },
    {
        id: 3,
        name: 'Cheese Cake',
        image: 'assets/images/3cake.jpg',
        category: 'dessert',
        label: '',
        price: '170',
        featured: false,
        description: 'A delectable, semi-sweet New York Style Cheese Cake, with cracker crust and spiced with Indian cardamoms',
    }
]

export default DISHES;
